<template>
    <div class="title-bar">
        <i class="return-btn van-icon van-icon-arrow-left" @click="handleBackBtnClick"/>
        <template v-for="item in routes">
            <span :key="item.path" v-if="item.meta.title !== '首页'"> {{ item.meta.title }}</span>
        </template>
    </div>
</template>

<script>
    export default {
        name: "TitleBar",
        props: {
            routes: {
                type: Array
            }
        },
        methods: {
            handleBackBtnClick() {
                this.$emit('routerBack');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .title-bar {
        height: 0.4rem;
        line-height: 0.4rem;
        color: #333;
        font-size: 0.17rem;
        font-weight: bold;
        text-align: center;
        background: #ffffff;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: $base-z-index + 1;

        .return-btn {
            position: absolute;
            left: 4%;
            display: block;
            top: 11px;
            padding: 0 5px;
            box-sizing: border-box;
        }

    }
</style>